<template>
  <el-dialog  :title="id ? `${$language('编辑')} ${$language('珠宝商品')}` : `${$language('添加')} ${$language('珠宝商品')}`"
    :visible.sync="show" :center="true" top="30px" width="80%" @close="close" @open="open">
    <el-form :model="form" ref="form" :rules="rules" :label-width="$store.getters.language == 'CN' ? '100px' : '200px'"
      v-loading="loading">
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane :label="$language('基本信息')" name="first">
          <el-form-item :label="$language('商品名称')" prop="name">
            <el-input v-model="form.name" clearable />
            <div>
              {{ $language(`请输入商品名称【品牌名(中文/英文)+产品名称(成色/材质/品类/元素/款式/系列)+附加产品特点】(例:爱恋ailian18K金镶红宝石情侣对戒促销款)`) }}
            </div>
          </el-form-item>
          <el-form-item :label="$language('商品规格')" prop="specs">
            <el-input v-model="form.specs" clearable />
            <div>
              {{ $language(`请输入商品规格(基本属性:(材质、功能、特征、风格)+规格参数:(型号、颜色、尺寸、规格、用途、货号)(例:18K 镶嵌1 克拉钻定制手寸 logo刻字)`)
              }}
            </div>
          </el-form-item>
          <el-form-item :label="$language('商品编码')" prop="code">
            <el-input v-model="form.code" :placeholder="$language('商品编码')" clearable />
          </el-form-item>
          <el-form-item :label="$language('计价类型')" prop="pricing_type">
            <el-radio-group v-model="form.pricing_type" @change="changeRadio">
              <el-radio :label="2">{{ $language('金工石计价') }}</el-radio>
              <el-radio :label="1">{{ $language('一口价') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$language('商品价格')" prop="price">
            <span v-if="form.pricing_type == 2">{{ form.price || '0.00' }}</span>
            <el-input v-else v-model="form.price" :placeholder="`${$language('请输入')} ${$language('商品价格')}`"
              clearable />
          </el-form-item>

          <el-form-item :label="$language('材质')" v-if="(form.pricing_type==2)">
            <div style="display: flex;">
              <el-select v-model="form.material_quality" :clearable="form.pricing_type == 1 ? true : false"
                :placeholder="$language('材质')" style="width: 220px;" @change="changeMaterial">
                <el-option v-for="(item, index) in materialList" :key="index" :label="item.label" :value="item.value"
                  :disabled="item.disabled">
                </el-option>
              </el-select>
              <el-select v-model="form.condition" :clearable="form.pricing_type == 1 ? true : false"
                :placeholder="$language('成色')" style="width: 220px;margin-left: 20px;" @change="changeQuality">
                <el-option v-for="(item, index) in qualityList" :label="item.label" :value="item.value" :key="index"
                  :disabled="item.disabled"></el-option>
              </el-select>
              <div style="display: flex;">
                <el-input v-model="form.condition_ratio" :placeholder="$language('成色值')" :disabled="form.condition != 4"
                  style="width: 220px;margin-left: 20px;" @input="iptEnter"></el-input>
                <div>%</div>
              </div>
            </div>
          </el-form-item>

          <el-form-item :label="$language('克重')" prop="gram_weight" v-if="(form.pricing_type==2)">
            <el-input type="number" v-model="form.gram_weight" :placeholder="$language('请输入')"></el-input>
          </el-form-item>

          <div style="display: flex;" v-if="(form.pricing_type==2)">
            <el-form-item :label="$language('料价')">
              <div class="price">￥</div>
              <el-input v-model="form.material_quality_price" :placeholder="$language('请输入')" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$language('主石金额')" v-if="(form.pricing_type==2)">
              <div class="price">￥</div>
              <el-input type="number" v-model="form.main_stone_amount" :placeholder="$language('请输入')"
                @input="iptEnter"></el-input>
            </el-form-item>
          </div>
          <div style="display: flex;" v-if="(form.pricing_type==2)">
            <el-form-item :label="$language('精品工费/克')">
              <div class="price">￥</div>
              <el-input type="number" v-model="form.labor_cost_gram" :placeholder="$language('请输入')" @input="iptEnter">
              </el-input>
            </el-form-item>
            <el-form-item :label="$language('工费/件')">
              <div class="price">￥</div>
              <el-input style="color: red;" type="number" v-model="form.labor_cost_piece"
                :placeholder="$language('请输入')" @input="iptEnter"></el-input>
            </el-form-item>
            <el-form-item :label="$language('基础工费/克')">
              <div class="price">￥</div>
              <el-input style="color: red;" type="number" v-model="form.labor_cost_gram_base"
                :placeholder="$language('请输入')" @input="iptEnter"></el-input>
            </el-form-item>
          </div>
          <el-form-item :label="$language('商品分类')" prop="third_category_id">
            <div style="display: flex">
              <el-select v-model="form.first_category_id" :placeholder="$language('一级分类')" clearable filterable
                @change="change($event, 1)">
                <el-option v-for="item in first_category" :key="item.id" :label="item.category_name" :value="item.id">
                </el-option>
              </el-select>
              <el-select v-model="form.second_category_id" :placeholder="$language('二级分类')" clearable filterable
                style="margin-left: 10px" @change="change($event, 2)" :disabled="form.first_category_id ? false : true">
                <el-option v-for="item in form_second_category" :key="item.id" :label="item.category_name"
                  :value="item.id">
                </el-option>
              </el-select>
              <el-select v-model="form.third_category_id" :placeholder="$language('三级分类')" clearable filterable
                style="margin-left: 10px" @change="change($event, 3)"
                :disabled="form.second_category_id ? false : true">
                <el-option v-for="item in form_third_category" :key="item.id" :label="item.category_name"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item :label="$language('商品品牌')" prop="jewelry_brand_id">
            <el-select v-model="form.jewelry_brand_id" :placeholder="$language('珠宝品牌')" clearable filterable
              style="width: 30%">
              <el-option v-for="(item, index) in brandList" :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$language('商品状态')">
            <el-radio-group v-model="form.status">
              <el-radio :label="1">{{ $language('上架') }}</el-radio>
              <el-radio :label="0">{{ $language('下架') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$language('热门状态')">
            <el-radio-group v-model="form.is_hot">
              <el-radio :label="1">{{ $language('热门') }}</el-radio>
              <el-radio :label="0">{{ $language('非热门') }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-tab-pane>
        <el-tab-pane :label="$language('商品主图')" name="second">
          <el-form-item :label="$language('封面图')" prop="cover_img">
            <uploadImg @getUrl="getUrl" :initUrl="form.complete_cover_img" :num="1"></uploadImg>
          </el-form-item>
          <el-form-item :label="$language('商品详情图')" prop="goods_image">
            <uploadImg @getUrl="getUrls" :initUrl="form.complete_goods_image" @sortImg="sortImg"></uploadImg>
            <div v-if="form.goods_image.length < 8">
              <div>{{ $language('图片:每张大小在300KB以内,格式为ipg/png,建议尺寸800*800，图片尽量底色保持纯色背景') }}</div>
              <div>{{ $language('视频:限1个，大小10M以内，格式Mp4，建议尺寸800*800px，3-10秒，画质清晰最优为360度，尽量底色保持纯色背景') }}</div>
            </div>
          </el-form-item>
        </el-tab-pane>
        <el-tab-pane :label="$language('商品详情')" name="third">
          <el-form-item prop="" label-width="0">
            <richText :RichText="form.details" @getRichText="getRichText"></richText>
          </el-form-item>
        </el-tab-pane>
      </el-tabs>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="resetForm('form')">{{ $language('重置') }}</el-button>
      <el-button type="primary" @click="submit('form')">{{ $language('确定') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import uploadImg from "@/components/uploadImage/uploadImage.vue";
import richText from "@/components/richText/richText.vue";
import { jewelryDetail, addJewelry, editJewelry, getMaterial } from "@/api/merchant/jewelry.js";
import { goodsCategory } from "@/api/api.js";
export default {
  props: ["value", "id", "brandList"],
  components: {
    uploadImg,
    richText,
  },
  data() {
    return {
      disable: false,
      loading: false,
      activeName: "first",
      show: false,
      first_category: [],
      form_second_category: [],
      form_third_category: [],
      materialList: [],
      qualityList: [],
      initForm: {
        name: "", //商品名称
        specs: "", //商品规格
        code: "", //商品编码
        price: "", //商品价格
        cover_img: "", //主图(封面图)
        first_category_id: "", //一级分类
        second_category_id: "", //二级分类
        third_category_id: "", //三级分类
        jewelry_brand_id: "", //商品品牌
        status: 1,
        is_hot: 1,
        details: "", //详情
        goods_image: [], //详情图
        complete_goods_image: [],
        complete_cover_img: '',
        pricing_type: '', // 一口价 1  金工石计价
        material_quality: '', //黄金 1 、白银 2、铂金 3、钯金 4
        material_quality_price:'',//料价
        condition: 4, //成色：18K金 1 、14K金 2 、9K金 3 、其他 4
        condition_ratio: '100', //成色比例值
        gram_weight: '', //克重
        main_stone_amount: '', //主石金额
        labor_cost_gram: '', //精品工费/克
        labor_cost_gram_base:'',//基础工费/克
        labor_cost_piece: '', //工费/件
      },
      form: {
        goods_image: []
      },
      goods_image: [], //排序后的数组
      is_video: 1,
      rules: '',
    };
  },
  watch: {
    value(n, o) {
      const isNum = (rule, value, callback) => {
        if (!value) {
          callback(new Error(this.$language('金额不能为空')));
          return;
        }
        const reg = /^\d+$|^\d*\.\d+$/g;
        if (!reg.test(value)) {
          callback(new Error(this.$language('请输入正确金额')));
          return;
        } else {
          callback();
        }
      }
      this.rules = {
        name: [{ required: true, message: this.$language('商品名称'), trigger: "blur" }],
        specs: [{ required: true, message: this.$language('商品规格'), trigger: "blur" }],
        code: [{ required: true, message: this.$language('商品编码'), trigger: "blur" }],
        price: [{ required: true, validator: isNum, trigger: "blur" }],
        third_category_id: [{ required: true, message: this.$language('商品分类'), trigger: "blur" }],
        jewelry_brand_id: [{ required: true, message: this.$language('商品品牌'), trigger: "blur" }],
        cover_img: [{ required: true, message: this.$language('商品主图'), trigger: 'blur' }],
        goods_image: [{ required: true, message: this.$language('商品详情图'), trigger: "blur" }],
        details: [{ required: true, message: this.$language('商品详情'), trigger: "blur" }],
        gram_weight: [{ required: true, message: this.$language('克重'), trigger: "blur" }],
        main_stone_amount: [{ required: true, message: this.$language('主石金额'), trigger: "blur" }],
        labor_cost_gram: [{ required: true, message: this.$language('精品工费/克'), trigger: "blur" }],
        labor_cost_gram_base: [{ required: true, message: this.$language('基础工费/克'), trigger: "blur" }],
        labor_cost_piece: [{ required: true, message: this.$language('工费/件'), trigger: "blur" }]
      }
      this.materialList = [{
        label: this.$language('黄金'),
        value: 1
      }, {
        label: this.$language('白银'),
        value: 2
      }, {
        label: this.$language('铂金'),
        value: 3
      }, {
        label: this.$language('钯金'),
        value: 4
      }]
      this.qualityList = [ {
        label: this.$language('18K金'),
        value: 1
      }, {
        label: this.$language('14K金'),
        value: 2
      }, {
        label: this.$language('9K金'),
        value: 3
      }, {
        label: this.$language('其他'),
        value: 4
      }]
      this.show = n;
    },
  },
  methods: {
    iptEnter() {
      if (this.form.pricing_type == 2) {
        this.form.price = this.getPrice()
      }
    },
    getPrice() {
      let total = 0
      let condition_price = 0
      if (this.form.condition != 4) {
        condition_price = Number(this.form.condition_ratio * 1 / 100).toFixed(6)
      } else {
        condition_price = Number(this.form.condition_ratio * 1 / 100).toFixed(6)
      }
      let material_price = Number((this.form.material_quality_price * 1) * condition_price + this.form.labor_cost_gram * 1+ this.form.labor_cost_gram_base * 1).toFixed(6)
      let other = Number(this.form.labor_cost_piece * 1 + this.form.main_stone_amount * 1).toFixed(6)
      total = Number(this.form.gram_weight * 1 * material_price) + Number(other)
      return total.toFixed(2)
    },
    init() {
      this.loading = true
      jewelryDetail(this.id).then((res) => {
        this.loading = false
        this.form = { ...res.data };

        if (!this.form.material_quality || this.form.material_quality == 0) {
          this.form.material_quality = ''
        }
        if (!this.form.condition || this.form.condition == 0) {
          this.form.condition = ''
        }

        this.form.goods_image = [];
        this.form.complete_goods_image = [];
        if (res.data.goods_image && res.data.goods_image.length != 0) {
          res.data.goods_image.forEach((item) => {
            let obj = {
              file_type: '',
              path: ''
            }
            obj.file_type = item.file_type
            obj.path = item.path
            this.form.complete_goods_image.push(item.complete_path);
            this.form.goods_image.push(obj)
          });
        }
        this.getSelect(this.form.first_category_id, 2);
        this.getSelect(this.form.second_category_id, 3);
        // if (this.form.pricing_type == 2) {
          this.changeMaterial(this.form.material_quality)
        // }
        if (this.form.condition != 4) {
          this.disable = true
        } else {
          this.disable = false
        }
      }).catch(err => {
        this.loading = false
      })
    },
    // 获取商品分类
    getSelect(pid, type) {
      goodsCategory({ pid }).then((res) => {
        if (res.code == 10000) {
          switch (type) {
            case 2:
              this.form_second_category = res.data;
              break;
            case 3:
              this.form_third_category = res.data;
              break;
            default:
              this.first_category = res.data;
          }
        }
      });
    },
    // 分类选择
    change(e, type) {
      switch (type) {
        case 1:
          this.form.second_category_id = "";
          this.form_second_category = [];
          this.form.third_category_id = "";
          this.form_third_category = [];
          this.getSelect(e, 2);
          break;
        case 2:
          this.form.third_category_id = "";
          this.form_third_category = [];
          this.getSelect(e, 3);
          break;
        default:
      }
    },
    // 切换计价类型
    changeRadio(e) {
      if (e == 2) {
        this.form.condition_ratio = (this.form.condition == 4 || this.form.condition == 0) ? '100' : this.form.condition_ratio

        this.form.condition = (this.form.condition == 4 || this.form.condition == 0) ? 4 : this.form.condition

        if (this.form.material_quality) {
          this.changeMaterial(this.form.material_quality)
        }

        this.form.price = this.getPrice()
      }
    },
    // 选择材料
    changeMaterial(e) {
      console.log(e,'选择材料选择材料选择材料选择材料');
      let obj = {}
      obj.material_quality = e
      getMaterial(obj).then(res => {
        this.form.material_quality_price = res.data
        if (this.form.pricing_type == 2) {
          this.form.price = this.getPrice()
        }
      })
    },
    // 选择成色
    changeQuality(e) {
      if (e != 4) {
        this.disable = true
      } else {
        this.disable = false
      }
      switch (e) {
        case 1:
          this.form.condition_ratio = '75.50'
          break;
        case 2:
          this.form.condition_ratio = '59.50'
          break;
        case 3:
          this.form.condition_ratio = '38.50'
          break;
        case 4:
          this.form.condition_ratio = '100'
          break;
        default:
          break;
      }
      if (this.form.pricing_type == 2) {
        this.form.price = this.getPrice()
      }
    },
    // 打开弹窗
    open() {
      this.getSelect();
      if (this.id) {
        this.loading = true
        this.$nextTick(() => {
          this.init();
        });
      } else {
        this.form = { ...this.initForm };
        this.form.goods_image = []
        this.form.complete_goods_image = []
        this.form.complete_cover_img = ''
      }
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },
    // 关闭弹窗
    close() {
      this.activeName = "first";
      this.form = { ...this.initForm };
      if (!this.id) {
        this.form.complete_cover_img = ''
      }
      this.$emit("input", false);
      this.$refs.form.clearValidate(); //清除验证规则
    },
    // 重置表单
    resetForm(formName) {
      this.form = { ...this.initForm };
      this.$refs[formName].resetFields();
    },
    // 提交表单
    submit(formName) {
      this.$refs[formName].validate((valid, obj) => {
        if (valid) {
          if (this.form.price <= 0) {
            this.$message({
              message: this.$language('商品价格需大于0'),
              type: 'warning'
            })
            return
          }
          let submitForm = { ...this.form,complete_goods_image:this.form.goods_image };
          submitForm.status = this.form.status ? 1 : 0;
          submitForm.is_hot = this.form.is_hot ? 1 : 0;
          // if(this.goods_image.length>0){
          //   submitForm.goods_image = this.goods_image
          // }
          let api;
          api = submitForm.id ? editJewelry : addJewelry;
          api(submitForm).then((res) => {
            if (res.code == 10000) {
              this.dialogVisible = false;
              this.$message({
                message: submitForm.id ? this.$language('编辑成功') : this.$language('添加成功'),
                type: "success",
              });
              if (!submitForm.id) {
                this.$emit('change', 1)
              }
              this.$emit('change')
            }
            this.close();
          });
        } else {
          for (let key in obj) {
            if (key == "price" || key == "specs" || key == "code" || key == "third_category_id" || key == "jewelry_brand_id") {
              this.activeName = "first";
              return;
            } else if (key == "cover_img" || key == "goods_image") {
              this.activeName = "second";
              return;
            } else if (key == "details") {
              this.activeName = "third";
              return;
            }
          }
          return false;
        }
      });
    },
    // 富文本
    getRichText(val) {
      this.form.details = val;
    },
    // 主图
    getUrl(data) {
      this.form.cover_img = data.file_path;
      this.form.complete_cover_img = data.visible_path;
    },
    // 详情图
    getUrls(data, index) {
      if (index || index == 0) {
        this.form.goods_image.splice(index, 1);
      } else {
        let obj = {
          file_type: '',
          path: ''
        }
        obj.path = data.file_path
        obj.file_type = data.file_path.substr(data.file_path.lastIndexOf(".") + 1, 4) == 'mp4' ? 2 : 1
        obj.complete_path = data.visible_path
        this.form.goods_image.push(obj);
        this.form.complete_goods_image.push(data.visible_path)
      }
      this.$forceUpdate()
    },
    // 排序
    sortImg(val) {
      this.form.goods_image = []
      this.goods_image = []
      val.forEach(item => {
        let str = item.substring(0, item.indexOf('.com/'))
        let str1 = item.substring(str.length + 5)
        let obj = {
          file_type: '',
          path: ''
        }
        obj.file_type = str1.substr(str1.lastIndexOf(".") + 1, 4) == 'mp4' ? 2 : 1
        obj.path = str1
        this.goods_image.push(obj)
      })
      this.form.goods_image = this.goods_image
    }
  },
};
</script>

<style>

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}
</style>
<style lang="scss" scoped>
::v-deep .el-dialog__footer {
  text-align: center !important;
}

::v-deep .el-upload-dragger {
  height: 70px;
  line-height: 70px;
}

.price {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 99;
  color: red;
}
</style>
